/* eslint-disable */
const addContactForm7Event = () => {
  const cf7Form = document.querySelector('.wpcf7');
  const submit = cf7Form.querySelector('.wpcf7-submit');

  if (cf7Form == null) {
    return;
  }

  cf7Form.addEventListener('wpcf7mailsent', (event) => {
    const { inputs } = event.detail;

    inputs.forEach((input) => {
      if (input.name == 'pdf-url') {
        if (submit.getAttribute('destino') && input.value) {
          input.value = submit.getAttribute('destino');
          window.location.href = submit.getAttribute('destino');
        }else if (!submit.getAttribute('destino') && input.value) {
          window.location.href = input.value;
        }
      }
    });
  }, false);
}

window.addEventListener('load', (event) => {
  addContactForm7Event();
});
